/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
'use strict';

require('isomorphic-fetch');

var log = require('../../utils/logger')('splitio-services:service');

function Fetcher(request) {
  return fetch(request).then(function (resp) {
    if (resp.ok) {
      return resp;
    } else {
      var message = resp.statusText;
      if (resp.status === 404) {
        message = 'Invalid API key or resource not found.';
      }
      log.error('Throw error because response status is not OK. Status: ' + resp.status + '. URL: ' + resp.url);

      throw Error(message);
    }
  });
}

module.exports = Fetcher;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/services/transport/index.js
// module id = 115
// module chunks = 11